export enum Terrain {
  MostlyFlat = 'MOSTLY_FLAT',
  Rolling = 'ROLLING',
  SomeHills = 'SOME_HILLS',
  Hilly = 'HILLY',
  OffRoad = 'OFF_ROAD',
} 